export default __webpack_public_path__ + "static/vip-c2339904902c4824ed9907956d909163.png";